import { render, staticRenderFns } from "./AjoutMonteMainBeta.vue?vue&type=template&id=5a4f3772&"
import script from "./AjoutMonteMainBeta.vue?vue&type=script&lang=js&"
export * from "./AjoutMonteMainBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports